import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import SSOSuiteApp from './app/SSOSuiteApp';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<StrictMode>
		<SSOSuiteApp />
	</StrictMode>
);
